module.exports = __webpack_public_path__ + "static/media/left.0fad5e26.svg";